<script setup>
import { storeToRefs } from 'pinia';
import { useLeagueStore } from '../stores/league-store';

/**
 * League
 */
const { league, loading } = storeToRefs(useLeagueStore());
</script>

<template>
  <ul class="nav nav-underline mb-3 flex-nowrap overflow-x-auto" v-if="!loading && league">
    <li class="nav-item">
      <RouterLink
        :to="{
          name: 'league.detail',
          params: { leagueId: league.id },
        }"
        class="nav-link"
      >
        About
      </RouterLink>
    </li>
  </ul>
</template>

<style scoped>
.nav-item a {
  padding-left: 0;
  padding-right: 0;
  margin-left: 0.875rem;
  margin-right: 0.875rem;
}
.league-nav a:hover {
  border-bottom: 3px solid var(--bs-primary);
}
.nav-link {
  border-bottom: 3px solid transparent;
}
.router-link-exact-active {
  border-bottom: 3px solid var(--bs-primary);
}


</style>
